const resources = {
    freeReturns: 'Free returns',
    exclusions: 'see details/exclusions.*',
    allPurchases: 'on all purchases.*'
};

export default function getResource(label) {
    return resources[label];
}
